export default __webpack_public_path__ + "static/media/SoundOn-Button.6563261b.svg";